import React, { useMemo } from "react";
import { useTranslate } from "@refinedev/core";
import { ChatSummaryStats } from "types/";
import { AnalyticsBarChart, type BarDatasetConfig } from "./AnalyticsBarChart";
import { analyticsTheme } from "./analyticsTheme";
import { getPercentageAxis, getCategoryAxis } from "./utils/";

const T_PREFIX = "media.projects.analytics.aiChatbot.questionTypes";

export interface QuestionTypesChartProps {
  data: ChatSummaryStats | null | undefined;
  loading: boolean;
}

export const QuestionTypesChart: React.FC<QuestionTypesChartProps> = ({
  data,
  loading,
}) => {
  const t = useTranslate();
  const chartOptions = useMemo(
    () => ({
      scales: { y: getPercentageAxis(), x: getCategoryAxis() },
    }),
    []
  );

  const labels = useMemo(
    () => [
      t(`${T_PREFIX}.clarifying`),
      t(`${T_PREFIX}.challenging`),
      t(`${T_PREFIX}.offTopic`),
      t(`${T_PREFIX}.repetitive`),
    ],
    [t]
  );

  const datasets = useMemo<BarDatasetConfig[]>(
    () => [
      {
        label: t(`${T_PREFIX}.pct`),
        data: [
          Math.round(data?.clarifying_pct ?? 0),
          Math.round(data?.challenging_pct ?? 0),
          Math.round(data?.off_topic_pct ?? 0),
          Math.round(data?.repetitive_pct ?? 0),
        ],
        color: analyticsTheme.datasetEmerald,
      },
    ],
    [data, t]
  );

  return (
    <AnalyticsBarChart
      title={t(`${T_PREFIX}.title`)}
      labels={labels}
      datasets={datasets}
      loading={loading}
      direction="vertical"
      height={200}
      chartOptions={chartOptions}
    />
  );
};
